import React, { Fragment } from 'react'
import { Breadcrumbs } from '../../../../AbstractElements';
import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import DaywiseReportView from './DaywiseReportView'

const DaywiseReport = () => {
    return (
        <Fragment>
            <Breadcrumbs parent="Report" title="Daywise Report" mainTitle="Daywise Report" />
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody>
                                <DaywiseReportView />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default DaywiseReport